import { ReactNode, useState, useEffect } from "react";
import { TabularMenuContext } from "./TabularMenuContext";

type TabularMenuProviderProps = {
  tabs: {
    label: string | ReactNode;
    component: ReactNode;
    onClick?: () => void;
  }[];
  children: ReactNode;
  index?: number;
};

export const TabularMenuProvider = ({
  tabs,
  children,
  index,
}: TabularMenuProviderProps) => {
  const [activeTabIndex, setActiveTabIndex] = useState(index ?? 0);

  useEffect(() => {
    setActiveTabIndex(index ?? 0);
  }, [index]);

  return (
    <TabularMenuContext.Provider
      value={{
        tabs,
        activeTabComponent: tabs[activeTabIndex].component,
        activeTabIndex,
        setActiveTabIndex,
      }}
    >
      {children}
    </TabularMenuContext.Provider>
  );
};
